export default __webpack_public_path__ + "static/media/mobile_phone-512.4b257164.png";